(() => {
  if (window.__sncStickyAtcLoaded) return;
  window.__sncStickyAtcLoaded = true;

  const STATE = {
    productInfo: null,
    sticky: null,
    nativeButton: null,
    nativeObserver: null,
    footerObserver: null,
    productObserver: null,
    pageObserver: null,
    footerVisible: false,
    hasPassedNative: false,
    refreshQueued: false,
  };

  const scheduleRefresh = () => {
    if (STATE.refreshQueued) return;
    STATE.refreshQueued = true;
    requestAnimationFrame(() => {
      STATE.refreshQueued = false;
      refresh();
    });
  };

  const getProductInfo = () => document.querySelector('product-info[id^="MainProduct-"]');

  const getSectionId = (productInfo) => productInfo?.dataset?.section || '';

  const getPriceText = (productInfo, sectionId) => {
    const priceRoot = document.getElementById(`price-${sectionId}`);
    if (!priceRoot || !productInfo.contains(priceRoot)) return '';

    const priceBox = priceRoot.querySelector('.price');
    const priceNode = priceBox?.classList.contains('price--on-sale')
      ? priceBox.querySelector('.price-item--sale.price-item--last')
      : priceBox?.querySelector('.price-item--regular');

    return (priceNode || priceRoot.querySelector('.price-item--last, .price-item--regular'))?.textContent?.trim() || '';
  };

  const getTitleText = (productInfo) =>
    productInfo.querySelector('.product__title h1')?.textContent?.trim() || document.title.replace(/\s*[|–-].*$/, '').trim();

  const getCurrentImage = (productInfo) =>
    productInfo.querySelector(
      '.product__media-item.is-active img, .product__media-item[aria-current="true"] img, .product__media-list .product__media-item:first-child img, .product__media img'
    );

  const buildSticky = (productInfo) => {
    const sectionId = getSectionId(productInfo);
    if (!sectionId) return null;

    const sticky = document.createElement('div');
    sticky.id = `SNCStickyATC-${sectionId}`;
    sticky.className = 'snc-sticky-atc';
    sticky.setAttribute('aria-hidden', 'true');

    sticky.innerHTML = `
      <div class="snc-sticky-atc__inner page-width">
        <div class="snc-sticky-atc__product">
          <div class="snc-sticky-atc__media" data-snc-sticky-media>
            <img class="snc-sticky-atc__image" data-snc-sticky-image alt="" width="54" height="54" loading="lazy">
          </div>
          <div class="snc-sticky-atc__meta">
            <div class="snc-sticky-atc__title" data-snc-sticky-title></div>
            <div class="snc-sticky-atc__price" data-snc-sticky-price></div>
          </div>
        </div>
        <button class="snc-sticky-atc__button" type="button" data-snc-sticky-button>
          <span class="snc-sticky-atc__desktop-label" data-snc-sticky-desktop-label></span>
          <span class="snc-sticky-atc__mobile-label" data-snc-sticky-mobile-label></span>
        </button>
      </div>`;

    document.body.appendChild(sticky);

    sticky.querySelector('[data-snc-sticky-button]')?.addEventListener('click', () => {
      const nativeButton = getNativeButton();
      if (!nativeButton || nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true') return;
      nativeButton.click();
      scheduleRefresh();
    });

    return sticky;
  };

  const getNativeButton = () => {
    const sectionId = getSectionId(STATE.productInfo);
    if (!sectionId) return null;
    const button = document.getElementById(`ProductSubmitButton-${sectionId}`);
    return button && STATE.productInfo.contains(button) ? button : null;
  };

  const setNativeButton = (button) => {
    if (button === STATE.nativeButton) return;

    STATE.nativeObserver?.disconnect();
    STATE.nativeButton = button;
    STATE.hasPassedNative = false;

    if (!button) return;

    STATE.nativeObserver = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return;
        if (entry.isIntersecting) {
          STATE.hasPassedNative = false;
        } else {
          STATE.hasPassedNative = entry.boundingClientRect.bottom <= 0;
        }
        updateVisibility();
      },
      { threshold: 0.01 }
    );
    STATE.nativeObserver.observe(button);
  };

  const bindFooter = () => {
    STATE.footerObserver?.disconnect();
    STATE.footerVisible = false;

    const footer = document.querySelector('footer.footer, footer, .footer');
    if (!footer) return;

    STATE.footerObserver = new IntersectionObserver(
      ([entry]) => {
        STATE.footerVisible = Boolean(entry?.isIntersecting);
        updateVisibility();
      },
      { threshold: 0, rootMargin: '0px 0px 80px 0px' }
    );
    STATE.footerObserver.observe(footer);
  };

  const updateVisibility = () => {
    if (!STATE.sticky) return;
    const shouldShow = Boolean(STATE.nativeButton && STATE.hasPassedNative && !STATE.footerVisible);
    STATE.sticky.classList.toggle('is-visible', shouldShow);
    STATE.sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
  };

  const syncContent = () => {
    const { productInfo, sticky, nativeButton } = STATE;
    if (!productInfo || !sticky) return;

    const sectionId = getSectionId(productInfo);
    const title = getTitleText(productInfo);
    const price = getPriceText(productInfo, sectionId);
    const sourceImage = getCurrentImage(productInfo);

    const titleNode = sticky.querySelector('[data-snc-sticky-title]');
    const priceNode = sticky.querySelector('[data-snc-sticky-price]');
    const mediaNode = sticky.querySelector('[data-snc-sticky-media]');
    const imageNode = sticky.querySelector('[data-snc-sticky-image]');
    const stickyButton = sticky.querySelector('[data-snc-sticky-button]');
    const desktopLabel = sticky.querySelector('[data-snc-sticky-desktop-label]');
    const mobileLabel = sticky.querySelector('[data-snc-sticky-mobile-label]');

    if (titleNode) titleNode.textContent = title;
    if (priceNode) priceNode.textContent = price;

    if (sourceImage && imageNode && mediaNode) {
      const nextSrc = sourceImage.currentSrc || sourceImage.src;
      if (nextSrc && imageNode.src !== nextSrc) imageNode.src = nextSrc;
      imageNode.alt = sourceImage.alt || title;
      mediaNode.hidden = false;
    } else if (mediaNode) {
      mediaNode.hidden = true;
    }

    if (!nativeButton || !stickyButton) {
      stickyButton?.setAttribute('disabled', 'disabled');
      updateVisibility();
      return;
    }

    const nativeLabel = nativeButton.firstElementChild?.textContent?.trim() || nativeButton.textContent?.trim() || 'Dodaj do koszyka';
    const disabled = nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true';
    const loading = nativeButton.classList.contains('loading');

    stickyButton.disabled = disabled;
    stickyButton.classList.toggle('is-loading', loading);
    stickyButton.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (desktopLabel) desktopLabel.textContent = nativeLabel;
    if (mobileLabel) mobileLabel.textContent = price && !disabled ? `${nativeLabel} · ${price}` : nativeLabel;

    updateVisibility();
  };

  const refresh = () => {
    if (!STATE.productInfo?.isConnected) {
      discover();
      return;
    }

    setNativeButton(getNativeButton());
    syncContent();
  };

  const cleanupBinding = () => {
    STATE.nativeObserver?.disconnect();
    STATE.footerObserver?.disconnect();
    STATE.productObserver?.disconnect();
    STATE.sticky?.remove();

    STATE.sticky = null;
    STATE.nativeButton = null;
    STATE.nativeObserver = null;
    STATE.footerObserver = null;
    STATE.productObserver = null;
    STATE.footerVisible = false;
    STATE.hasPassedNative = false;
  };

  const bind = (productInfo) => {
    if (!productInfo || productInfo === STATE.productInfo) return;

    cleanupBinding();
    STATE.productInfo = productInfo;
    STATE.sticky = buildSticky(productInfo);
    if (!STATE.sticky) return;

    bindFooter();
    setNativeButton(getNativeButton());

    STATE.productObserver = new MutationObserver(scheduleRefresh);
    STATE.productObserver.observe(productInfo, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'disabled', 'aria-disabled', 'src', 'srcset'],
    });

    syncContent();
  };

  const discover = () => {
    const productInfo = getProductInfo();
    if (productInfo && productInfo !== STATE.productInfo) bind(productInfo);
  };

  const start = () => {
    discover();
    STATE.pageObserver = new MutationObserver(() => {
      if (!STATE.productInfo?.isConnected || !STATE.sticky?.isConnected) discover();
    });
    STATE.pageObserver.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', discover);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
